import React from "react";
import "../App.css";
import { Link } from "react-router-dom";
// import { DarkModeSwitch } from "react-toggle-dark-mode";
import BackgroundAnimate from "./backgroundAnimate.jsx";
import { saveAs } from "file-saver";
import Projects from "./projects.jsx";
import Technologies from "./technologies.jsx";
import Contact from "./contact.jsx";
import About from "./about.jsx";
import { useLanguage } from "../utils/LanguageContext";
import en from "../utils/languages/en.jsx";
import fr from "../utils/languages/fr.jsx";

const Main = ({ theme }) => {
  const { language } = useLanguage();
  const translations = {
    en,
    fr,
  };

  const currentTranslations = translations[language];

  const saveFile = () => {
    saveAs(
      language === "en"
        ? "https://res.cloudinary.com/ujuzi/image/upload/v1690534701/mes_nouveaux_cv_2023/MWAFRIKA_CV_english_psv9lv.pdf"
        : "https://res.cloudinary.com/ujuzi/image/upload/v1690534701/mes_nouveaux_cv_2023/MWAFRIKA_CV_french_ais0yp.pdf",
      "mwafrika_josue.pdf"
    );
  };
  return (
    <>
      <main className="mx-auto xxxs:px-5 xxs:px-5 xs:px-5 sm:px-5 mt-10">
        {/* dark:bg-gray-900 */}
        <section
          className="grid grid-cols-2 max-w-7xl xxxs:grid-cols-1 xxs:grid-cols-1 xs:grid-cols-1 md:mb-4"
          id="home"
        >
          <div className="mx-auto my-auto w-full ml-2 relative">
            <h2
              className={`${
                theme === "dark" ? "title-dark" : "title"
              } leading-6`}
            >
              <span className="whitespace-pre-line">
                {" "}
                {language === "en" ? "Hi there ," : "Bonjour ,"}
              </span>
              <br />
              {language === "en" ? "I'm MWAFRIKA" : "Je suis MWAFRIKA"}
            </h2>
            <p className="text-2xl pb-14 text-gray-400 light:text-red-500 xxxs:text-xl xxs:text-xl xs:text-xl md:text-2xl dark:text-gray-600">
              {currentTranslations.homeDetails}
            </p>
            <div className="flex gap-x-8">
              <Link to="/#contact" className="p-0 m-0">
                <button
                  className="bg-gradient-to-r from-violet-500 to-sky-500 rounded-lg xxxs:px-5 xxxs:text-lg xxs:px-5 xxs:text-xl xs:px-5 sm:px-5 xs:text-xl sm:text-xl py-2 shadow-lg hover:shadow-xl hover:bg-gray-600 hover:text-white
            transition-all duration-200 ease hover:bg-gradient-to-l 
            "
                >
                  {language === "en" ? "Hire Me" : "M'engager"}
                </button>
              </Link>

              <div
                onClick={saveFile}
                className="flex justify-end text-xl xxxs:text-lg gap-3 items-center underline underline-offset-8 decoration-white dark:decoration-blue-600 dark:text-blue-600 cursor-pointer"
              >
                {/* <p>Download CV</p> */}
                {language === "en" ? "Download CV" : "Mon CV"}
                {currentTranslations.download}
              </div>
            </div>
          </div>
          <BackgroundAnimate theme={theme} />
        </section>
        <Projects theme={theme} />
        <Technologies theme={theme} />
        <About theme={theme} />

        <div className="w-full mt-28 border border-slate-50/10"></div>
        <Contact theme={theme} />
      </main>
      <div className="w-full mt-20 border border-slate-50/10 dark:border-slate-200/50"></div>
    </>
  );
};

export default Main;
